let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54SiS")).then(() => parcelRequire('es92x'));